import { User, PlusCircle } from 'lucide-react';
import { useState } from 'react';

const ParentsSection = () => {
	// 임시 데이터 상태 관리
  const [parents, setParents] = useState([
    { name: "홍길동", email: "hong@example.com", phone: "010-1234-5678" }
  ]);
  const [editParentIndex, setEditParentIndex] = useState(null);

  // 핸들러 임시 구현
  const handleAddParent = () => {
    if (parents.length < 2) {
      setParents([...parents, { name: "", email: "", phone: "" }]);
      setEditParentIndex(parents.length); // 추가하자마자 수정 모드로
    }
  };

  const handleParentDelete = (index) => {
    setParents(parents.filter((_, i) => i !== index));
  };

  const handleParentEdit = (index) => {
    setEditParentIndex(index);
  };

  const handleParentChange = (index, field, value) => {
    const newParents = [...parents];
    newParents[index][field] = value;
    setParents(newParents);
  };

  const handleParentComplete = (index) => {
    setEditParentIndex(null);
  };
	return (
		<section className="space-y-6">
  {/* 섹션 헤더 */}
  <div className="flex flex-wrap gap-2 items-baseline">
    <h2 className="text-m text-gray-500 font-bold tracking-tighter">부모 / 보호자</h2>
    <span className="text-xs text-slate-400 font-medium">부모 / 보호자는 최대 2명까지 등록 가능합니다.</span>
  </div>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    {parents.map((parent, index) => (
      <div key={index} className="space-y-4">
        {editParentIndex !== index ? (
          /* [카드 형태] 기존 디자인과 핸들러 그대로 유지 */
          <div 
            onClick={() => handleParentEdit(index)}
            className="relative p-5 border rounded-xl bg-gray-50 flex flex-col items-end cursor-pointer hover:border-blue-400 transition-colors group min-h-[250px]"
          >
            <div className="flex space-x-3 mb-1">
              <button 
                className="text-xs text-blue-500 hover:text-blue-700 font-medium"
                onClick={(e) => {
                  e.stopPropagation();
                  handleParentEdit(index);
                }}
              >
                수정
              </button>
              <button 
                className="text-xs text-red-500 hover:text-red-700 font-medium"
                onClick={(e) => {
                  e.stopPropagation();
                  handleParentDelete(index);
                }}
              >
                삭제
              </button>
            </div>
            <div className="flex flex-col justify-center w-full text-left pb-3 border-b">
              <div className="flex-shrink-0 w-12 h-12 bg-white border border-gray-200 rounded-full flex items-center justify-center shadow-sm mb-3">
                <User className="w-6 h-6 text-gray-400" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[15px] font-bold text-gray-900 truncate">
                  {parent.name || "이름 없음"}
                </p>
                <div className="mt-1 space-y-0.5">
                  <p className="text-xs text-gray-500 flex items-center">
                    <span className="w-12 text-gray-400 uppercase tracking-tighter flex-shrink-0">이메일</span>
                    <span className="truncate">{parent.email || "-"}</span>
                  </p>
                  <p className="text-xs text-gray-500 flex items-center">
                    <span className="w-12 text-gray-400 tracking-tighter flex-shrink-0">연락처</span>
                    <span>{parent.phone || "-"}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          /* [입력 모드] 기존 디자인 그대로 유지 */
          <div className="p-5 border rounded-xl bg-white space-y-2 shadow-sm">
            <input
              type="text"
              placeholder="이름을 입력해주세요."
              value={parent.name}
              onChange={(e) => handleParentChange(index, 'name', e.target.value)}
              className="w-full px-4 py-3 rounded-lg border text-sm"
            />
            <input
              type="text"
              placeholder="이메일을 입력해주세요."
              value={parent.email}
              onChange={(e) => handleParentChange(index, 'email', e.target.value)}
              className="w-full px-4 py-3 rounded-lg border text-sm"
            />
            <input
              type="text"
              placeholder="연락처를 입력해주세요."
              value={parent.phone}
              onChange={(e) => handleParentChange(index, 'phone', e.target.value)}
              className="w-full px-4 py-3 rounded-lg border text-sm"
            />
            <button
              type="button"
              onClick={() => handleParentComplete(index)}
              disabled={!parent.name || !parent.email || !parent.phone}
              className={`w-full px-4 py-3 rounded-lg text-sm font-semibold transition whitespace-nowrap mt-2
                ${parent.name && parent.email && parent.phone
                  ? "bg-purple-600 text-white hover:bg-purple-700"
                  : "bg-gray-200 text-gray-400 cursor-not-allowed"}
              `}
            >
              입력 완료
            </button>
          </div>
        )}
      </div>
    ))}

    {/* 추가 버튼 (카드 형태 유지) */}
    {parents.length < 2 && (
      <button
        type="button"
        onClick={handleAddParent}
        className="h-full min-h-[250px] border-2 border-dashed border-slate-200 rounded-2xl flex flex-col items-center justify-center gap-2 text-slate-400 hover:bg-slate-50 hover:border-slate-300 transition-all group"
      >
        <div className="p-3 bg-slate-50 rounded-full  transition-transform">
          <PlusCircle className="w-8 h-8 text-slate-300 " />
        </div>
      </button>
    )}
  </div>
</section>

	);
}

export default ParentsSection;